module.exports = __webpack_public_path__ + "img/magnifying-glass-minus.c20fc5ce.svg";